import React from 'react';
import { Box } from '@chakra-ui/react';

type Props = {
    children?: React.ReactNode;
};

export const Divider: React.FC<Props> = ({ children }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            textAlign="center"
            width="full"
            _before={{
                content: `""`,
                flex: 1,
                borderBottom: '1px solid #CBD5E0',
                marginRight: '1rem'
            }}
            _after={{
                content: `""`,
                flex: 1,
                borderBottom: '1px solid #CBD5E0',
                marginLeft: '1rem'
            }}>
            {children}
        </Box>
    );
};
